import { Group, Text } from '@mantine/core';
import type { ReactNode } from 'react';

type ReminderDetailItemProps = {
  label: string;
  value: ReactNode;
};

export const ReminderDetailItem = ({ label, value }: ReminderDetailItemProps) => (
  <Group wrap="nowrap">
    <Text fw="bold" c="dimmed" fz="xs" w={120}>
      {label}
    </Text>
    {value}
  </Group>
);
